import styled, { css } from "styled-components";

const titles = css`
  display: flex;
  flex-direction: column;
  margin-top: 167px;
  width: 100%;
  align-items: center;
`;
export const Container = styled.div`
  ${({ title }) => title && titles};
  padding: 0 100px;
  margin-bottom: 110px;
  @media (max-width: 1049px) {
    margin-bottom: 30px;
    padding: 0 50px;

    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
  }
  animation: meals-appear 1s ease-out forwards;

  @keyframes meals-appear {
    from {
      opacity: 0;
      transform: translateY(4rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const Range = css`
  ::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 50%;
    width: 150px;
    height: 4px;
    background: crimson;
    transform: translateX(-50%);
  }
  ::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: crimson;
    transform: translateX(-50%);
  }
  margin-bottom: 60px;
`;

const ContentTitle = css`
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #000;
`;
const TitleMedia = css`
  @media (max-width: 1049px) {
    font-size: 38px;
  }
`;
export const Title = styled.div`
  position: relative;
  color: crimson;
  font-size: 35px;
  font-weight: 800;
  ${({ range }) => range && Range};
  ${({ contentTitle }) => contentTitle && ContentTitle};
  ${({ title }) => title && TitleMedia};
`;
const Content = css`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 20px;
  @media (max-width: 1049px) {
    flex-direction: column;
    font-size: ${({ myTitle }) => myTitle && "32px"};
    text-align: center;
  }
`;
const ColLeft = css`
  position: relative;
  /* width: 45%; */
`;
const ColRight = css`
  position: relative;
  width: 45%;
  @media (max-width: 1049px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  animation: colRight 1s ease-out forwards;
  @keyframes colRight {
    from {
      opacity: 0;
      transform: translateX(8rem);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
const ImgCard = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 450px;
  @media (max-width: 1049px) {
    padding: 0 30px;
    width: 100px;
  }
  animation: appear 1s ease-out forwards;

  @keyframes appear {
    from {
      opacity: 0;
      transform: translateX(-8rem);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
const Column = css`
  @media (max-width: 1049px) {
    position: relative;
  }
`;

export const Wrapper = styled.div`
  ${({ content }) => content && Content};
  ${({ colLeft }) => colLeft && ColLeft};
  ${({ colRight }) => colRight && ColRight};
  ${({ imgCard }) => imgCard && ImgCard};
  ${({ column }) => column && Column};
`;

export const Img = styled.img`
  left: 0;
  width: 500px;
  height: 500px;
  @media (max-width: 1049px) {
    width: 300px;
    height: 300px;
  }
`;
export const Desc = styled.p`
  @media (max-width: 1049px) {
  }
`;
export const Button = styled.button`
  color: #fff;
  background-color: crimson;
  font-size: 17px;
  font-weight: 600;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 50px;
  border: none;
  user-select: none;
  cursor: pointer;
  letter-spacing: 1px;
  margin: 30px 0;
  :hover {
    color: ${({ about }) => (about ? "#fff" : "#000")};
    background-color: ${({ about }) => (about ? "#000" : "#fff")};
    transition: 0.2s ease-in-out;
  }
  :active {
    transform: scale(1.3);
  }
  @media (max-width: 1049px) {
  }
`;
